import { cn } from '@bem-react/classname'
import { FC, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { Memo } from '@/hoc/Memo'
import { useAppDispatch, useAppSelector } from '@/core/store/hooks'
import {
  authSelector,
  currentUserSelector,
  roleSelector,
} from '@/modules/AccountPage/store/accont.selector'
import useWindowSize from '@/hooks/useWindowSize'

import { Container } from '@/components/Container'
import { Language } from '@/components/Language'
import { Toggler } from '@/components/Toggler'

import './Header.scss'
import { RoleUserModel } from '@/core/services/Token/model/TokenModel'
import { paths } from '@/config'
import {
  changeRole,
  setConnectedResellerId,
} from '@/modules/AccountPage/store/accont.slice'

const cnHeader = cn('Header')

export interface HeaderSchema {
  className?: string
}

export const Header: FC<HeaderSchema> = Memo(({ className }: HeaderSchema) => {
  const { t } = useTranslation('translation')
  const { pathname } = useLocation()
  const { lessTablet, lessMobile } = useWindowSize()
  const isAuth = useAppSelector(authSelector)
  const currentUser = useAppSelector(currentUserSelector)
  const role = useAppSelector(roleSelector)

  const [open, setOpen] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (lessMobile && pathname) {
      setOpen(false)
    }
  }, [pathname])

  const openMobileMenu = useCallback(() => {
    setOpen(!open)
  }, [open])

  function handleSignOutClick() {
    dispatch(setConnectedResellerId(''))
    dispatch(changeRole(RoleUserModel.User))
  }

  return (
    <header className={cnHeader(null, [className])}>
      <Container>
        <div className={cnHeader('line')}>
          <Link
            to={isAuth ? '/cabinet/licenses' : '/'}
            className={cnHeader('logo')}
          >
            {lessTablet ? (
              <img
                src='/img/favicon-dinamica-generale.png'
                alt='Registration'
              />
            ) : (
              <img
                src='/img/logo.png'
                alt='Registration'
                className={cnHeader('img')}
              />
            )}
          </Link>
          <div className={cnHeader('right')}>
            {((lessMobile && open && isAuth) || (!lessMobile && isAuth)) && (
              <div className={cnHeader('menu')}>
                {role === RoleUserModel.SuperUser && (
                  <Link to='/cabinet/statistic' className={cnHeader('button')}>
                    <i
                      className={cnHeader('icon', ['fa-solid fa-chart-line'])}
                    ></i>
                    {t('Statistic')}
                  </Link>
                )}

                <Link to='/cabinet/account' className={cnHeader('button')}>
                  <i className={cnHeader('icon', ['fa-solid fa-user'])}></i>
                  {t('Account')}
                </Link>
                {currentUser?.emailConfirmed && (
                  <Link
                    //to={paths.ADD_LICENSE_PAGE}
                    to={paths.CREATE_LICENSE_BY_SERIAL_NUMBER}
                    className={cnHeader('button', {
                      disabled: role === RoleUserModel.SuperUser,
                    })}
                  >
                    <i className={cnHeader('icon', ['fa-solid fa-plus'])}></i>

                    {t('Add License')}
                  </Link>
                )}
                <Link
                  to='/'
                  className={cnHeader('button')}
                  onClick={handleSignOutClick}
                >
                  <i
                    className={cnHeader('icon', [
                      'fa-solid fa-arrow-right-from-bracket',
                    ])}
                  ></i>

                  {t('Sign Out')}
                </Link>
              </div>
            )}
            <Language />

            {lessMobile && isAuth && (
              <Toggler
                open={openMobileMenu}
                blue
                className={cnHeader('toggler')}
                isOpen={open}
              />
            )}
          </div>
        </div>
      </Container>
    </header>
  )
})
